/* eslint-disable */
import React from "react";
import RenderITOfficerPage from "../RenderITOfficerPage";
import AuditTrailPanel from "../../Components/AuditTrailPanel";

function AuditTrail() {
  return (
    <RenderITOfficerPage title="Audit Trail">
      <AuditTrailPanel accent="cyan" />
    </RenderITOfficerPage>
  );
}

export default AuditTrail;
